import { render, staticRenderFns } from "./company-panel--entrepreneur.vue?vue&type=template&id=621943ac&scoped=true&"
import script from "./company-panel--entrepreneur.vue?vue&type=script&lang=ts&"
export * from "./company-panel--entrepreneur.vue?vue&type=script&lang=ts&"
import style0 from "./company-panel--entrepreneur.vue?vue&type=style&index=0&id=621943ac&lang=scss&scoped=true&"
import style1 from "./company-panel--entrepreneur.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621943ac",
  null
  
)

export default component.exports